import {getWorkshops} from "../services";
import {addWorkshops} from "../store/actions";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {filterByLanguages} from "../utils/filterByLanguages";
import {filterByTags} from "../utils/filterByTags";

interface Props {
    dispatch: Function
}

export const useGetWorkshops = ({dispatch}: Props) => {
    const {workshops} = getWorkshops()

    // @ts-ignore
    const filteredLanguages = useSelector((state) => state.filters.languages)
    // @ts-ignore
    const filteredTags = useSelector((state) => state.filters.tags)

    useEffect(() => {
        const byLanguage = filterByLanguages({languages: filteredLanguages, items: workshops})
        const workshopsToDisplay = filterByTags({tags: filteredTags, items: byLanguage})

        dispatch(addWorkshops({workshops: workshopsToDisplay}))

    }, [dispatch, workshops, filteredLanguages, filteredTags])
}